import { AuthService } from 'src/app/services/auth.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Termin } from 'sharedTypes/termin';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';
import { ChooseClientComponent } from '../choose-client/choose-client.component';

@Component({
    selector: 'app-termin-editor',
    standalone: false,
    templateUrl: './termin-editor.component.html',
    styleUrls: ['./termin-editor.component.scss'],
})
export class TerminEditorComponent implements OnInit {
    users: any[] = [];
    onlyMe = false;
    savedTermin = new Termin();
    constructor(
        public glo: GlobalService,
        public firebaseService: FirebaseService,
        public authService: AuthService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<TerminEditorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { termin: Termin },
    ) {
        const usersS = this.glo.users.sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        if (!this.data.termin.maIdNoBreakfast) {
            this.data.termin.maIdNoBreakfast = {};
        }
        this.users = usersS
            .filter((u) => !u.inaktiv && u.hatTermine)
            .concat(usersS.filter((u) => !u.inaktiv && !u.hatTermine));
    }

    async ngOnInit() {
        this.savedTermin = JSON.parse(JSON.stringify(this.data.termin));
        if (this.data.termin.maId && this.data.termin.maIds.length === 0) {
            this.data.termin.maIds = [this.data.termin.maId];
        }
        const myMaId = this.authService.getUid();
        if (this.data.termin.maIds.length === 1 && myMaId === this.data.termin.maIds[0]) {
            this.onlyMe = true;
        }
        console.log(myMaId);
        console.log(this.data.termin.maId);
        console.log(this.data.termin.maIds);
        console.log(this.onlyMe);
    }

    async saveTermin() {
        this.data.termin.EndTime = new Date(new Date(this.data.termin.EndTime).setHours(12)).toISOString();
        this.data.termin.StartTime = new Date(new Date(this.data.termin.StartTime).setHours(12)).toISOString();
        if (this.data.termin.type !== 'client') {
            this.data.termin.maIdUmsatz = {};
            this.data.termin.clientId = '';
        }
        if (this.data.termin.Id) {
            await this.firebaseService.updateTermin(this.data.termin, this.savedTermin);
        } else {
            await this.firebaseService.createTermin(this.data.termin);
        }
        this.dialogRef.close();
    }

    generateUmsatzObj() {
        const umsatzObj: any = {};
        this.data.termin.maIds.forEach((maId) => {
            if (this.data.termin.maIdUmsatz && this.data.termin.maIdUmsatz[maId]) {
                umsatzObj[maId] = this.data.termin.maIdUmsatz[maId];
            } else {
                umsatzObj[maId] = 0;
            }
        });
        this.data.termin.maIdUmsatz = umsatzObj;
    }

    selectKunde() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        const dialogRef = this.dialog.open(ChooseClientComponent, cfg);
        dialogRef.afterClosed().subscribe((choosen) => {
            if (choosen && choosen.client) {
                this.data.termin.clientId = choosen.client.clientId;
            }
            // console.log('The dialog was closed');
        });
    }

    sanitizeUmsatz(maId: string) {
        this.data.termin.maIdUmsatz[maId] = this.glo.sI(this.data.termin.maIdUmsatz[maId]);
    }

    sanitizeBreakfast(maId: string) {
        this.data.termin.maIdNoBreakfast[maId] = this.glo.sI(this.data.termin.maIdNoBreakfast[maId]);
    }

    trackByFn(index: any, item: any) {
        return index;
    }

    async deleteTermin() {
        const res = await this.glo.confirm('Wirklich löschen?').toPromise();
        if (!res) {
            return;
        }
        this.data.termin.deleted = true;
        this.saveTermin();
    }
}
